import React, { useEffect, useState } from "react";
import "./App.css";
import ContactButtons from "./components/ContactButtons";
import TopBar from "./components/TopBar";
import NavBar from "./components/NavBar";
import TripsSection from "./components/TripsSection";
import FloatingContact from "./components/FloatingContact";
import CoverPage from "./components/CoverPage";
import ContactPage from "./components/ContactPage";
import FooterPage from "./components/FooterPage";
import Weather from "./components/Weather";
import WishlistPage from "./components/WishlistPage";
import TripHistoryOverlay from "./components/TripHistoryOverlay";

function App({ categories }) {
  const [showWishlist, setShowWishlist] = useState(false);
  const [showTripHistory, setShowTripHistory] = useState(false);

  return (
    <div>
      <NavBar
        categories={categories}
        onOpenWishlist={() => setShowWishlist(true)}
        onOpenTripHistory={() => setShowTripHistory(true)}
      />

      <CoverPage
        imageSrc="/img/cover/beach-cover.jpg"
        altText="Dandeli & Gokarna Cover"
      />
      <FloatingContact />
      <TripsSection categories={categories} />
      <ContactPage />
      <FooterPage />

      {showWishlist && <WishlistPage onClose={() => setShowWishlist(false)} />}
      {showTripHistory && (
        <TripHistoryOverlay onClose={() => setShowTripHistory(false)} />
      )}
    </div>
  );
}

export default App;
